import { render, staticRenderFns } from "./RatingQuestion.vue?vue&type=template&id=5a424a57&"
import script from "./RatingQuestion.vue?vue&type=script&lang=ts&"
export * from "./RatingQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports